import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
// import { getSubscription } from "../../FindagramAdmin/BaseUrl/SubscriptionApi";

const Navdata = () => {
    const history = useHistory();

    const [isDashboard, setIsDashboard] = useState(false);
    const [isApps, setIsApps] = useState(false);
    const [isAuth, setIsAuth] = useState(false);
    const [isPages, setIsPages] = useState(false);
    const [isBaseUi, setIsBaseUi] = useState(false);
    const [isAdvanceUi, setIsAdvanceUi] = useState(false);
    const [isForms, setIsForms] = useState(false);
    const [isTables, setIsTables] = useState(false);
    const [isCharts, setIsCharts] = useState(false);
    const [isIcons, setIsIcons] = useState(false);
    const [isMaps, setIsMaps] = useState(false);
    const [isMultiLevel, setIsMultiLevel] = useState(false);
    const [subscriptionData, setSubscriptionData] = useState(null);
    const [subscriptionLoading, setSubscriptionLoading] = useState(true);

    const [iscurrentState, setIscurrentState] = useState("Dashboard");

    function updateIconSidebar(e) {
        if (e && e.target && e.target.getAttribute("subitems")) {
            const ul = document.getElementById("two-column-menu");
            const iconItems = ul.querySelectorAll(".nav-icon.active");
            let activeIconItems = [...iconItems];
            activeIconItems.forEach((item) => {
                item.classList.remove("active");
                var id = item.getAttribute("subitems");
                if (document.getElementById(id))
                    document.getElementById(id).classList.remove("show");
            });
        }
    }

    useEffect(() => {
        document.body.classList.remove("twocolumn-panel");
        if (iscurrentState !== "Dashboard") {
            setIsDashboard(false);
        }
        if (iscurrentState !== "Apps") {
            setIsApps(false);
        }
        if (iscurrentState !== "Auth") {
            setIsAuth(false);
        }
        if (iscurrentState !== "Pages") {
            setIsPages(false);
        }
        if (iscurrentState !== "BaseUi") {
            setIsBaseUi(false);
        }
        if (iscurrentState !== "AdvanceUi") {
            setIsAdvanceUi(false);
        }
        if (iscurrentState !== "Forms") {
            setIsForms(false);
        }
        if (iscurrentState !== "Tables") {
            setIsTables(false);
        }
        if (iscurrentState !== "Charts") {
            setIsCharts(false);
        }
        if (iscurrentState !== "Icons") {
            setIsIcons(false);
        }
        if (iscurrentState !== "Maps") {
            setIsMaps(false);
        }
        if (iscurrentState !== "MuliLevel") {
            setIsMultiLevel(false);
        }
        if (iscurrentState === "Widgets") {
            history.push("/widgets");
            document.body.classList.add("twocolumn-panel");
        }
    }, [
        history,
        iscurrentState,
        isDashboard,
        isApps,
        isAuth,
        isPages,
        isBaseUi,
        isAdvanceUi,
        isForms,
        isTables,
        isCharts,
        isIcons,
        isMaps,
        isMultiLevel,
    ]);

    // Fetch subscription data from API
    // useEffect(() => {
    //     const fetchSubscriptionData = async () => {
    //         try {
    //             const response = await getSubscription();
    //             setSubscriptionData(response?.responseData);
    //         } catch (error) {
    //             console.error("Failed to fetch subscription:", error);
    //             setSubscriptionData(null);
    //         } finally {
    //             setSubscriptionLoading(false);
    //         }
    //     };

    //     fetchSubscriptionData();
    // }, []);


useEffect(() => {
    const fetchSubscriptionData = () => {
        // Get subscriptionType from localStorage
        const subscriptionType = localStorage.getItem("subscriptionType") || "free";
        setSubscriptionData({ subscriptionType });
        setSubscriptionLoading(false);
    };

    const handleStorageChange = (event) => {
        if (event.key === "subscriptionType") {
            console.log("New subscriptionType value:", event.newValue);
            setSubscriptionData({ subscriptionType: event.newValue || "free" });
        }
    };

    const handleSubscriptionUpdated = () => {
        console.log("Subscription updated event received");
        fetchSubscriptionData(); // Re-fetch subscriptionType from localStorage
    };

    // Initial fetch from localStorage
    fetchSubscriptionData();

    // Add event listeners for storage changes and subscription updates
    window.addEventListener("storage", handleStorageChange);
    window.addEventListener("subscriptionUpdated", handleSubscriptionUpdated);

    // Cleanup event listeners on component unmount
    return () => {
        window.removeEventListener("storage", handleStorageChange);
        window.removeEventListener("subscriptionUpdated", handleSubscriptionUpdated);
    };
}, []);






    // Define the menu item
    const menuItems = [
        {
            id: "businessList",
            label: "Business Profile",
            icon: "ri-user-3-line",
            link: "/business-profile",
        },
        {
            id: "deals",
            label: "Deals",
            icon: "ri-restaurant-2-line",
            link: "/#",
            stateVariables: isDashboard,
            click: function (e) {
                e.preventDefault();
                setIsDashboard(!isDashboard);
                setIscurrentState("Dashboard");
                updateIconSidebar(e);
            },
            subItems: [
                {
                    id: "dealList",
                    label: "Daily Special",
                    icon: "ri-restaurant-line",
                    link: "/deal-list",
                },
                {
                    id: "lunchDealList",
                    label: "Lunch Special",
                    icon: "ri-restaurant-line",
                    link: "/lunch-deal-list",
                },
                {
                    id: "happyHoursDealList",
                    label: "Happy Hours",
                    icon: "ri-restaurant-line",
                    link: "/happy-hour-deal-list",
                },
            ],
        },
       
        // ...(!subscriptionLoading && subscriptionData?.subscriptionType && 
        //     subscriptionData?.subscriptionType !== "free"
        //     ? [
        //           {
        //               id: "subscriptionDetail",
        //               label: "Subscription Detail",
        //               icon: "mdi mdi-credit-card-outline",
        //               link: "/subscription-detail",
        //           },
        //       ]
        //     : []),

        ...(!subscriptionLoading && subscriptionData?.subscriptionType && 
    subscriptionData?.subscriptionType !== "free"
    ? [
          {
              id: "subscriptionDetail",
              label: "Subscription Detail",
              icon: "mdi mdi-credit-card-outline",
              link: "/subscription-detail",
          },
      ]
    : []),
      
    ];

    return <React.Fragment>{menuItems}</React.Fragment>;
};

export default Navdata;